// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1klCtCz9W5mjQL6Id82fKF","input":"_2G6mzcPyXv7psHxP45OCg8","label":"WokIvaMHf7xA0cUeukj8","active":"_2qyBkFNSeR1cXvS7y78_NJ"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/FormInput/styles.scss
 ** module id = 440
 ** module chunks = 0
 **/